<script setup lang="ts">
import type { IProps } from './'
const props = defineProps<IProps>()
</script>

<template>
  <div class="space-y-3" :class="{ 'rounded-lg bg-white p-4': props.variant === 'white' }">
    <Heading v-if="props.headingText" :tag="props.headingTag ?? 'h2'" class="h4">{{
      props.headingText
    }}</Heading>
    <slot />
  </div>
</template>
